<template>
  <div id="slider">
    <div class="container1 d-flex justify-content-around">
      <div class="opciones">
        <input type="radio" id="i1" name="images" checked />
        <input type="radio" id="i2" name="images" />
        <input type="radio" id="i3" name="images" />
        <input type="radio" id="i4" name="images" />
        <input type="radio" id="i5" name="images" />
        <div class="slide_img" id="one">
          <div class="subtitle">
            <strong>Desarrollamos soluciones informáticas orientadas a las personas.</strong>
          </div>
          <label class="prev" for="i5">
            <span>&#x2039;</span>
          </label>
          <label class="next" for="i2">
            <span>&#x203a;</span>
          </label>
        </div>

        <div class="slide_img" id="two">
          <div class="parrafo">
            <center>
              <strong>Exploramos.</strong>
            </center>
            <br />Las necesidades de los usuarios y las condiciones en la que
            operará la solución informática a desarrollar, tomando en cuenta en forma integral los
            aspectos técnicos y operacionales del entorno.
          </div>

          <label class="prev" for="i1">
            <span>&#x2039;</span>
          </label>
          <label class="next" for="i3">
            <span>&#x203a;</span>
          </label>
        </div>

        <div class="slide_img" id="three">
          <div class="parrafo">
            <center>
              <strong>Descubrimos.</strong>
            </center>
            <br />Los elementos esenciales que conceptualizan el desarrollo
            del producto y las herramientas tecnológicas necesarias para su programación e
            implementación con la mejor relación costo–beneficio para el cliente.
          </div>
          <label class="prev" for="i2">
            <span>&#x2039;</span>
          </label>
          <label class="next" for="i4">
            <span>&#x203a;</span>
          </label>
        </div>

        <div class="slide_img" id="four">
          <div class="parrafo">
            <center>
              <strong>Diseñamos.</strong>
            </center>
            <br />Utilizando las mejores prácticas para garantizar de manera ágil
            la obtención incremental del producto final.
          </div>
          <label class="prev" for="i3">
            <span>&#x2039;</span>
          </label>
          <label class="next" for="i5">
            <span>&#x203a;</span>
          </label>
        </div>

        <div class="slide_img" id="five">
          <div class="parrafo">
            <center>
              <strong>Construimos.</strong>
            </center>
            <br />El sistema Web y las aplicaciones móviles que integran la
            solución, manteniendo como centro de atención las personas y su satisfacción como
            usuarios.
          </div>
          <label class="prev" for="i4">
            <span>&#x2039;</span>
          </label>
          <label class="next" for="i1">
            <span>&#x203a;</span>
          </label>
        </div>
        <div class="slide_img" id></div>
        <div id="nav_slide">
          <div class="first">
            <label for="i1" class="dots" id="dot1">
              <img src="@/assets/abeja_Blanca.png" alt />
            </label>
          </div>
          <div class="second">
            <label for="i2" class="dots" id="dot2">
              <div class="dentro">Exploramos</div>
            </label>
            <label for="i3" class="dots" id="dot3">
              <div class="dentro">Descubrimos</div>
            </label>
          </div>
          <div class="third">
            <label for="i4" class="dots" id="dot4">
              <div class="dentro">Diseñamos</div>
            </label>
            <label for="i5" class="dots" id="dot5">
              <div class="dentro">Construimos</div>
            </label>
          </div>
        </div>
      </div>
      <div class="contenido"></div>
    </div>
  </div>
</template>
<script>
export default {};
</script>
<style scoped>
#slider {
  height: 300px;
  color: #242325;
  background-color: #ebf5ee;
}
#i1,
#i2,
#i3,
#i4,
#i5 {
  display: none;
}
img {
  display: none;
  margin-top: 0px;
  height: 70px;
}
.container1 {
  margin: 0 auto;
  margin: 0 3%;
  padding: 0;
  position: relative;
  width: 100;
  height: 100%;
  user-select: none;
  background-color: transparent;
}
.opciones {
  width: 100%;
  height: 100%;
  position: absolute;
}
.contenido {
  width: 100%;
  height: 100%;
}

.slide_img {
  position: absolute;
  height: 300px;
  width: 100%;
  background-color: #ebf5ee;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
}
.slide_img img {
  width: inherit;
  height: inherit;
}
.subtitle {
  font-size: 18px;
  width: 70%;
  margin-top: -40px;
}
.parrafo {
  margin-top: -50px;
  width: 80%;
  font-size: 16px;
  color: #242325;
  text-align: justify;
}

.prev,
.next {
  width: 12%;
  height: inherit;
  position: absolute;
  top: 0;
  /* background-color: rgba(88, 88, 88, 0.2);
  color: rgba(244, 244, 244, 0.9); */
  z-index: 99;
  transition: 0.45s;
  cursor: pointer;
  text-align: center;
}

.next {
  right: -3%;
}
.prev {
  left: -3%;
}
label {
  display: flex;
  align-items: center;
  justify-content: center;
}
label span {
  position: relative;
  font-size: 100pt;
  top: 25%;
  left: 0;
  transform: translateY(-50%);
}

.prev:hover,
.next:hover {
  transition: 0.3s;
  /* background-color: rgba(88, 88, 89, 0.8);
  color: #ffffff; */
}
#nav_slide {
  width: 100%;
  top: 75%;
  height: auto;
  position: absolute;
  text-align: center;
  z-index: 99;
  cursor: default;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  margin-top: 20px;
}
.first {
  display: flex;
}
.second {
  display: flex;
}
.third {
  margin-top: 0px;
  display: flex;
}
.dentro {
  margin-top: 50px;
}
#nav_slide .dots {
  color: white;
  font-size: 18px;
  top: -5px;
  width: 35px;
  height: 40px;
  margin: 0 4px;
  position: relative;
  clip-path: polygon(50% 0%, 100% 25%, 100% 75%, 50% 100%, 0% 75%, 0% 25%);
  display: inline-block;
  background-color: #ffdb96;
  transition: 0.4s;
}

#nav_slide .dots:hover {
  cursor: pointer;
  background-color: #dfab0d;
  font-weight: bold;
  transition: 0.25s;
}

.slide_img {
  z-index: -1;
}

#i1:checked ~ #one,
#i2:checked ~ #two,
#i3:checked ~ #three,
#i4:checked ~ #four,
#i5:checked ~ #five {
  z-index: 9;
  animation: scroll 1s ease-in-out;
}
#i1:checked ~ #nav_slide #dot1,
#i2:checked ~ #nav_slide #dot2,
#i3:checked ~ #nav_slide #dot3,
#i4:checked ~ #nav_slide #dot4,
#i5:checked ~ #nav_slide #dot5 {
  background-color: #dfab0d;
  font-weight: bold;
  background-image: url("../assets/abeja_Blanca.png");
  background-position: center;
  background-size: 25px;
  background-repeat: no-repeat;
}

@keyframes scroll {
  0% {
    opacity: 0.4;
  }
  100% {
    opacity: 1;
  }
}
@media screen and (min-width: 768px) {
  img {
    display: inline;
    margin-top: 20px;
  }
  .opciones {
    position: relative;
  }
  .slide_img {
    left: 100%;
  }
  .subtitle {
    margin-top: 0;
  }
  .parrafo {
    margin-top: 0;
    font-size: 18px;
  }
  #nav_slide {
    top: 30px;
    position: relative;
  }
  .third {
    margin-top: -22px;
  }
  #nav_slide .dots {
    font-size: 18px;
    width: 110px;
    height: 121px;
  }
  .next {
    right: -2%;
  }
  .prev {
    left: -2%;
  }
  label span {
    top: 30%;
  }
  #i1:checked ~ #nav_slide #dot1,
  #i2:checked ~ #nav_slide #dot2,
  #i3:checked ~ #nav_slide #dot3,
  #i4:checked ~ #nav_slide #dot4,
  #i5:checked ~ #nav_slide #dot5 {
    background-image: none;
  }
}
@media screen and (min-width: 1024px) {
  img {
    margin-top: 30px;
    height: 90px;
  }
  .slide_img {
    height: 350px;
  }
  .dentro {
    margin-top: 70px;
  }
  #slider {
    height: 350px;
  }
  #nav_slide {
    margin: 0;
  }
  #nav_slide .dots {
    height: 165px;
    width: 150px;
  }
  .third {
    margin-top: -34px;
  }
  label span {
    top: 26%;
  }
  .next {
    right: -1.5%;
  }
  .prev {
    left: -1.5%;
  }
}
@media screen and (min-width: 1200px) {
  #slider {
    padding: 0 7%;
  }
}
@media screen and (min-width: 1440px) {
  #slider {
    padding: 0 14%;
  }
}
</style>